import React from "react";
import Line from "../../../assets/line2.svg";
import laptop from "../../../assets/9.png";
import videoUrl from "../../../assets/process_in_interface_mockup.gif";

export default function Context() {
  return (
    <div className="bg-gray-100">
      <h2 className="text-3xl bg-gray-100 pt-8 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:pt-20 pb-5">
        How it{" "}
        <span className="relative inline-block">
          Works
          <img
            src={Line}
            alt="Underline decoration"
            className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
          />
        </span>
      </h2>
      <div className="p-8 lg:pr-20 lg:pl-10 pb-20">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between">
          {/* Left: Text Content */}
          <div className="text-left md:w-[55%] lg:mt-10 mb-6 md:pr-6">
            <h2 className="text-3xl sm:text-4xl lg:text-[41px] lg:leading-[1.3em] font-bold">
              <span className="relative inline-block">
                Sign Up{" "}
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-8 lg:top-[47px]"
                />
              </span>{" "}
              for Access.
            </h2>
            <p className="text-lg my-3">
              Create an account to receive your unique API key and access our
              detailed documentation.
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-[41px] lg:leading-[1.3em] font-bold">
              Make Your{" "}
              <span className="relative inline-block">
                Requests
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
                />
              </span>
            </h2>
            <p className="text-lg my-3">
              Use your API key to search for emails based on your chosen
              parameters.
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-[41px] lg:leading-[1.3em] font-bold">
              Receive Verified{" "}
              <span className="relative inline-block">
                Emails
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
                />
              </span>{" "}
            </h2>
            <p className="text-lg my-3">
              Get reliable results you can use confidently in your campaigns.
            </p>
          </div>

          <div className="md:w-[45%] mt-16 2xl:mt-8 2xl:ml-14 flex justify-center items-center relative">
            <div className="absolute -top-[2%] left-[13%] w-[74%] h-full overflow-hidden rounded-lg">
              <img
                src={videoUrl}
                alt="sd-video"
                className="absolute top-0 left-0 w-full h-[110px] min-[360px]:mt-5 min-[360px]:h-[127px] min-[500px]:h-[190px] min-[500px]:mt-7 min-[610px]:mt-[35px] min-[610px]:h-[230px] md:h-[160px] md:mt-6 min-[940px]:h-[190px] lg:h-[237px] lg:mt-[35px] mt-4 -ml-1.5"
              />
            </div>
            <img
              src={laptop}
              alt="Laptop showcasing application"
              className="w-full h-[145px] min-[360px]:h-[170px] min-[500px]:h-[250px] min-[610px]:h-[310px] md:h-[190px] min-[940px]:h-[235px] lg:h-[315px] 2xl:h-[390px] z-10"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
